// ABOUTME: Per-tab analytics session id, persisted in sessionStorage so it survives reloads.
// ABOUTME: Falls back to an in-memory id when sessionStorage is unavailable.

const SESSION_KEY = 'coolpim.analytics.sessionId';
let fallbackSessionId: string | null = null;

// One id per browser tab: sessionStorage is tab-scoped and survives reloads.
export function getAnalyticsSessionId(): string {
    try {
        const existing = window.sessionStorage.getItem(SESSION_KEY);
        if (existing) return existing;
        const created = crypto.randomUUID();
        window.sessionStorage.setItem(SESSION_KEY, created);
        return created;
    } catch {
        fallbackSessionId = fallbackSessionId ?? crypto.randomUUID();
        return fallbackSessionId;
    }
}
